import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PublicHeader from '../components/PublicHeader';

import HeroSection from '../components/home/HeroSection';
import AgentFeatureSection from '../components/home/AgentFeatureSection';
import BeforeAfterSection from '../components/home/BeforeAfterSection';
import PricingSection from '../components/home/PricingSection';
import FAQSection from '../components/home/FAQSection';
import CTASection from '../components/home/CTASection';

const Home = () => {
  const navigate = useNavigate();
  const [autoplayVideo, setAutoplayVideo] = useState(false);

  return (
    <div className="min-h-screen bg-stone-50">
      <PublicHeader />

      <HeroSection
        title="Your AI Agent writes photo captions automatically"
        subhead="Automatically writes titles, captions, and tags for your Flickr, SmugMug, and Unsplash photos. No manual work, ever."
        ctaPrimary="Start Free Trial"
        ctaSecondary="Watch Demo"
        trustLine="Works with Flickr, SmugMug & Unsplash · Never stores images · Official OAuth"
        media={{
          type: 'video',
          embedUrl: `https://www.youtube-nocookie.com/embed/nmelXvRzht0?rel=0&modestbranding=1&autoplay=${autoplayVideo ? 1 : 0}&mute=${autoplayVideo ? 1 : 0}&enablejsapi=1`,
          alt: 'Product demo video showing photo enhancement process',
        }}
        onPrimary={() => navigate('/login')}
        onSecondary={() => {
          setAutoplayVideo(true);
          const heroSection = document.querySelector('#hero');
          if (heroSection) {
            heroSection.scrollIntoView({ behavior: 'smooth' });
          }
        }}
      />

      <AgentFeatureSection onStartTrial={() => navigate('/login')} />

      <BeforeAfterSection onGetFreePhotos={() => navigate('/login')} />

      <PricingSection onStartTrial={() => navigate('/login')} />

      <FAQSection />

      <CTASection onGetFreePhotos={() => navigate('/login')} />
    </div>
  );
};

export default Home;
